
const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'No freight Indent',
  description: 'No freight indent settings',
  sortOrder: 1,
  name: 'noFreightIndent',
  documentKey: 'no_freight_indent',
  values: {
    no_freight_default_transporter: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: '',
      displayName: 'No Feight Default Transporter',
      documentKey: 'no_freight_default_transporter',
    },
    no_freight_default_vehicle_type: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: '',
      displayName: 'No Freight Default Vehicle Type',
      documentKey: 'no_freight_default_vehicle_type',
    },
  },
};
